import { fetchListCatalogs } from 'common/api/documentCatalog';
import {
    ALLIANCE_DOCUMENTS_CATEGORY,
    REQUEST_FORM_TYPE,
} from 'common/constants';

import {
    FETCH_REQUEST_FORM_DOCUMENTS,
    FETCH_REQUEST_FORM_DOCUMENTS_FAILURE,
    FETCH_REQUEST_FORM_DOCUMENTS_SUCCESS,
} from '../../actionTypes';
import { installerProfileActions } from '../../reducer';

export default () => (dispatch) => {
    dispatch(installerProfileActions[FETCH_REQUEST_FORM_DOCUMENTS]());

    fetchListCatalogs()
        .then((response) => {
            const dataFiltered = response.data.data.filter(
                (item) =>
                    item.category === ALLIANCE_DOCUMENTS_CATEGORY &&
                    item.type === REQUEST_FORM_TYPE,
            );
            dispatch(
                installerProfileActions[FETCH_REQUEST_FORM_DOCUMENTS_SUCCESS](
                    dataFiltered,
                ),
            );
        })
        .catch((error) =>
            dispatch(
                installerProfileActions[FETCH_REQUEST_FORM_DOCUMENTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
